import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

const FiltrCompany = ({ onChange, value, menuItems }) => {
  const { t } = useTranslation();
  return (
    <FormControl sx={{ minWidth: 120 }}>
      <Select
        value={value}
        onChange={onChange}
        onBlur={(e) => e.stopPropagation()}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{ marginLeft: '20px', marginTop: '5px', minWidth: '120px' }}
      >
        <MenuItem value="">
          <em>{t('all')}</em>
        </MenuItem>
        {menuItems}
      </Select>
    </FormControl>
  );
};

export default FiltrCompany;
